import { useMutation, useQueryClient } from "@tanstack/react-query";

import toast from "react-hot-toast";
import { deleteLectureQuizOption as deleteLectureQuizOptionApi } from "../../../../services/dashboard/apiQuizes";

export function useDeleteQuizOption() {
  const queryClient = useQueryClient();

  const {
    mutate: deleteQuizOption,
    isLoading: isDeleting,
    error,
  } = useMutation({
    mutationFn: deleteLectureQuizOptionApi,
    onSuccess: () => {
      toast.success("تم حذف الأختيار بنجاح");

      queryClient.invalidateQueries({
        queryKey: ["quizOptionsDB"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { deleteQuizOption, isDeleting, error };
}
